import React from 'react';
import styled from '@emotion/styled';

import { useT } from 'client/i18n/hooks/useT';
import { QuoteWaveIcon } from '../Icons';
import { QuoteImage } from './QuoteImage';
import { IMAGE_MAP } from './constants';
import { SCREEN_BREAKPOINTS } from '../../constants';

const Container = styled.div`
  position: relative;
  display: grid;
  align-content: center;
  width: 100%;
  height: 438px;
  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    height: 438px;
  }

  @media (max-width: 900px) {
    height: 300px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    height: 200px;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    height: 150px;
  }

  svg {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1300px;
  margin: auto;
  padding: 0 24px;
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    padding: 0;
  }
`;

/**
 * image 1 and 2 are hidden for now. we didn't get the podcast that we the quote
 * section, so these outer images weren't used, but we might add them back
 */
export const QuoteImagesBlock = () => {
  const t = useT();
  const imageAlt = {
    imageOne: t(
      'AdsByAnchorScreen.Quote.QuoteImagesBlock.HostingImageAlt',
      'Man hosting podcast with other contributors',
      'Ads by Anchor page image screenreader information'
    ),
    imageTwo: t(
      'AdsByAnchorScreen.Quote.QuoteImagesBlock.RSlashLogoImageAlt',
      'Logo for "rSlash" podcast',
      'Ads by Anchor page image screenreader information'
    ),
    imageThree: t(
      'AdsByAnchorScreen.Quote.QuoteImagesBlock.AddTrackImageAlt',
      'Man adding a new track to his podcast',
      'Ads by Anchor page image screenreader information'
    ),
  };
  return (
    <Container>
      <ImageContainer>
        <QuoteImage
          image={IMAGE_MAP.imageOne}
          alt={imageAlt.imageOne}
          isHidden={true}
        />
        <QuoteImage
          image={IMAGE_MAP.imageTwo}
          alt={imageAlt.imageTwo}
          isHidden={false}
        />
        <QuoteImage
          image={IMAGE_MAP.imageThree}
          alt={imageAlt.imageThree}
          isHidden={true}
        />
      </ImageContainer>
      <QuoteWaveIcon />
    </Container>
  );
};
